import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';

import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import React from 'react';
import SMSIcon from '@mui/icons-material/Sms';
import TOTPIcon from '@mui/icons-material/ScreenLockPortrait';

const MFA_OPTIONS = {
    SMS: {
        icon: SMSIcon,
        primary: 'auth.amplify.mfa.sms.title',
        secondary: 'auth.amplify.mfa.sms.description',
        value: 'SMS',
    },
    TOTP: {
        icon: TOTPIcon,
        primary: 'auth.amplify.mfa.totp.title',
        secondary: 'auth.amplify.mfa.totp.description',
        value: 'TOTP',
    },
};

const MFAOptionsList = props => {
    const { options, onSelect } = props;
    return (
        <List>
            {options
                .map(option => {
                    if (!MFA_OPTIONS[option]) {
                        return null;
                    }
                    const { icon: IconComponent, value, primary, secondary } = MFA_OPTIONS[option];
                    return (
                        <ListItem key={value} button onClick={() => onSelect(value)}>
                            <ListItemAvatar>
                                <Avatar>
                                    <IconComponent />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<Locale path={primary} />}
                                secondary={<Locale path={secondary} />}
                            />
                        </ListItem>
                    );
                })
                .filter(Boolean)}
        </List>
    );
};

MFAOptionsList.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string),
    onSelect: PropTypes.func,
};

export default MFAOptionsList;
